module.exports = __webpack_public_path__ + "img/hillhall-v-474x632.5f6eacbf.jpg";